<template>
    <li class="post">
        <div class="post__title" @click="toggle">{{ message.title }}</div>
        <div class="post__body">
            <div
                v-show="!opened"
                class="post__preview"
                @click="toggle"
            >{{ contentStripped }}</div>
            <div
                v-show="opened"
                class="post__content"
            >
                <div v-html="message.content"></div>
                <div class="post__collapse" @click="toggle">Свернуть</div>
            </div>
        </div>
    </li>
</template>

<script>
    import helpers from '@/common/helpers.js';

    export default {
        name: 'MessagesListItem',
        props: ['message'],
        data () {
            return {
                opened: false
            }
        },
        computed: {
            contentStripped () {
                return helpers.common.stripTags(this.message.content);
            }
        },
        methods: {
            toggle () {
                this.opened = !this.opened;
            }
        }
    }
</script>

<style lang="scss">
    .post {
        list-style: none;
        padding: 2em 0;
        border-bottom: solid 1px silver;

        &:hover .post__title {
            opacity: 0.5;
        }

        &__title {
            display: inline-block;
            font-size: 1.3em;
            color: #333;
            margin-bottom: 0.5em;
            cursor: pointer;
        }

        &__preview {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            cursor: pointer;
        }

        &__content {
            p {
                margin: 1em 0;
                font-size: 1.2em;
                color: #666;
            }

            a {
                color: steelblue;

                &:hover {
                    color: navy;
                }
            }

            h3 {
                font-size: 1.6em;
                font-weight: normal;
                color: #333;
            }

            img {
                max-width: 100%;
                margin: 1em 0;
            }
        }

        &__collapse {
            display: inline-block;
            color: steelblue;
            cursor: pointer;
            border-bottom: dotted 1px;
            margin: 1em 0;

            &:hover {
                opacity: 0.7;
            }
        }
    }
</style>